module.exports = __webpack_public_path__ + "static/img/so3_3.78a3c5b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/solution/pic/so3_3.jpg
// module id = h7/9
// module chunks = 11